module.exports = __webpack_public_path__ + "07ae55e484c0bc7da6f041241c7571c9.png";